import React from 'react';
import { Helmet } from 'react-helmet';
import './pagestyles/Pursuits.css';

const Pursuits = () => {
  return (
    <>
      <Helmet>
        <title>Pursuits - Luxury Lifestyle & Travel | Redbox Global</title>
        <meta name="description" content="Explore luxury lifestyle, exclusive travel destinations, haute couture fashion, fine dining, and luxury watches. Your guide to sophisticated living and fine pursuits." />
        <meta name="keywords" content="luxury lifestyle, luxury travel, haute couture, fine dining, Michelin stars, luxury watches, high-end fashion, exclusive destinations, luxury living" />
        
        {/* Open Graph / Facebook */}
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://redboxglobal.com/pursuits" />
        <meta property="og:title" content="Pursuits - Luxury Lifestyle & Travel | Redbox Global" />
        <meta property="og:description" content="Explore luxury lifestyle, exclusive travel destinations, haute couture fashion, fine dining, and luxury watches. Your guide to sophisticated living." />
        <meta property="og:image" content="https://images.unsplash.com/photo-1566073771259-6a8506099945?w=1200&h=630&fit=crop" />
        
        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:url" content="https://redboxglobal.com/pursuits" />
        <meta name="twitter:title" content="Pursuits - Luxury Lifestyle & Travel | Redbox Global" />
        <meta name="twitter:description" content="Explore luxury lifestyle, exclusive travel destinations, haute couture fashion, fine dining, and luxury watches." />
        <meta name="twitter:image" content="https://images.unsplash.com/photo-1566073771259-6a8506099945?w=1200&h=630&fit=crop" />
        
        {/* Additional SEO */}
        <meta name="robots" content="index, follow" />
        <meta name="author" content="Redbox Global" />
        <link rel="canonical" href="https://redboxglobal.com/pursuits" />
      </Helmet>
      
      <div className="page-container">
      <div className="page-header">
        <h1>Pursuits</h1>
        <p className="page-subtitle">Luxury lifestyle, travel, culture, and fine living</p>
      </div>
      
      <div className="page-content">
        <a href="/article/luxury-travel-destinations-2026" style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}>
          <div className="featured-article">
            <div className="featured-image">
              <img src="https://images.unsplash.com/photo-1566073771259-6a8506099945?w=1200&h=600&fit=crop" alt="Luxury travel" />
            </div>
            <div className="featured-content">
              {/* <span className="article-category">Cover Story</span> */}
              <h2>The World's Most Exclusive Travel Destinations</h2>
              <p>Discover hidden gems and ultra-luxury resorts that define the pinnacle of travel experiences in 2026. From private islands to mountain retreats.</p>
              <span className="article-meta">This Week's Feature</span>
            </div>
          </div>
        </a>

        <div className="content-grid">
          <a href="/article/haute-couture-spring-collection" style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}>
            <article className="article-card">
              <div className="article-image">
                <img src="https://images.unsplash.com/photo-1539109136881-3be0616acf4b?w=600&h=400&fit=crop" alt="Fashion" />
              </div>
              <div className="article-content">
                {/* <span className="article-category">Fashion</span> */}
                <h2>Haute Couture Spring Collection Highlights</h2>
                <p>The most stunning pieces from Paris Fashion Week that are redefining luxury fashion.</p>
                <span className="article-meta">February 3, 2026</span>
              </div>
            </article>
          </a>

          <a href="/article/fine-dining-michelin-stars" style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}>
            <article className="article-card">
              <div className="article-image">
                <img src="https://images.unsplash.com/photo-1414235077428-338989a2e8c0?w=600&h=400&fit=crop" alt="Fine Dining" />
              </div>
              <div className="article-content">
                {/* <span className="article-category">Gastronomy</span> */}
                <h2>New Michelin Three-Star Restaurants Revealed</h2>
                <p>Meet the chefs and restaurants earning the industry's highest honor this year.</p>
                <span className="article-meta">February 2, 2026</span>
              </div>
            </article>
          </a>

          <a href="/article/luxury-watches-investment" style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}>
            <article className="article-card">
              <div className="article-image">
                <img src="https://images.unsplash.com/photo-1523170335258-f5ed11844a49?w=600&h=400&fit=crop" alt="Luxury Watches" />
              </div>
              <div className="article-content">
                {/* <span className="article-category">Timepieces</span> */}
                <h2>Luxury Watches as Alternative Investments</h2>
                <p>Why collectors are viewing rare timepieces as serious portfolio diversification.</p>
                <span className="article-meta">February 1, 2026</span>
              </div>
            </article>
          </a>
        </div>
      </div>
    </div>
    </>
  );
};

export default Pursuits;
